var TopMenuComponent = /** @class */ (function () {
    function TopMenuComponent() {
    }
    return TopMenuComponent;
}());
export { TopMenuComponent };
